import { render, staticRenderFns } from "./PanelParticipationContainer.vue?vue&type=template&id=534a656c"
import script from "./PanelParticipationContainer.vue?vue&type=script&lang=js"
export * from "./PanelParticipationContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports